export const DIRECTOR_NAME = "Denise French";

export const OFFICE_PHONE = "8033272344";

export const TRANSCRIPTS_EMAIL = "transcripts@palmettoha.org";
export const TRANSCRIPTS_NAME = "Tara Bruce";

export const NOTIFICATIONS_NAME = "PHA Notifications";
export const NOTIFICATIONS_EMAIL = "phanotifications@palmettohomeschool.org";

export const SUPPORT_EMAIL = "support@palmettohomeschool.org";

export const MEMBER_DOC_LINK =
  "https://www.dropbox.com/sh/wzp8wpn6ehzgykc/AAAVWD5De4sSj4j8a3H9kjJla?dl=0";
